<template>
    <section class="bg-indigo-200">
        <div class="container pt-40 pb-20 mx-auto sm:w-full md:w-3/4 lg:w-2/4">
            <div class="w-full px-4 mb-4 lg:mx-auto lg:w-1/2">
                <h1 class="mb-2 text-xl font-semibold text-center text-gray-800 dark:text-gray-200">ชำระเงินด้วย QR code</h1>
                <h1 class="mb-2 text-xl font-semibold text-center text-gray-800 dark:text-gray-200">
                    {{ showMoney(amount) }}    บาท
                </h1>
                <!-- <img :src="`data:image/png;base64, ${qrcode}`" alt="" srcset=""> -->
                <img :src="qrcode" alt="PromptPay QR Code" srcset="">
                <p v-if="showText == false" class="flex justify-center">loading...</p>
            </div>
            <hr>
            <!-- <div class="flex justify-center w-full px-4 mt-4 mb-4 lg:mx-auto lg:w-2/2" v-if="showText == true && isMobilePhone">
                <button @click="downloadImage" :disabled="isDownloading" class="inline-flex items-center px-4 py-2 font-semibold text-white bg-blue-500 rounded hover:bg-blue-600 disabled:opacity-60">
                    <i class="fa-regular fa-circle-down"></i>&nbsp;&nbsp;
                    {{ isDownloading ? 'กำลังบันทึก...' : 'บันทึก QR Code ลงรูปภาพ' }}
                </button>
            </div> -->
            <div class="flex justify-center w-full px-4 mt-4 mb-4 lg:mx-auto lg:w-2/2" v-if="showText == true">
                <p class="font-bold">ขั้นตอนการชำระเงินโดยใช้ Thai QR code ผ่านแอปธนาคาร</p>
            </div>
            <div class="w-full px-4 mt-4 mb-4 lg:mx-auto lg:w-2/2" v-if="showText == true">
                <p>1. หากท่านใช้โทรศัพท์มือถือ และต้องการชำระผ่านแอพธนาคาร ให้ท่านจับภาพหน้าจอโดยให้เห็น QR Code ทั้งหมดไว้ก่อน</p>
                <p>2. เข้าสู่ระบบแอพธนาคาร</p>
                <p>3. เลือกเมนู โอนเงิน หรือ Scan QR Code หรือ Upload QR</p>
                <p>4. ใช้โทรศัพท์มือถือเปิด QR Code ที่จับภาพหน้าจอไว้ก่อนหน้า หรือ scan QR ที่ปรากฏบนหน้าจอนี้</p>
                <p>5. ตรวจสอบชื่อบัญชีว่าตรงกับชื่อบัญชีข้างต้นหรือไม่</p>
                <p>6. เมื่อทำรายการเรียบร้อย หน้าจอจะแสดงผลสำเร็จ</p>
            </div>
        </div> 
    </section>
</template>

<script>
    import filter from '@/helpers/filter'   
    import http from '@/services/AuthService'
    export default{
        created(){
            let logedIn = this.$store.getters['authMember/logedIn']
            if(logedIn){
                this.retreiveQrcode()
            }else{
                this.retreiveQrcodeWithoutLogin()
            }
            window.scrollTo({top: 0, behavior: 'smooth'})
        },
        data(){
            return{
                qrcode: '',
                amount: 1,
                timer: '',
                checkingCount: 0,
                showText: false,
                isMobilePhone: false,
                isDownloading: false,
            }
        },
        mounted(){
            this.isMobilePhone = this.detectMobilePhone()
        },
        methods:{
            detectMobilePhone() {
                const ua = navigator.userAgent
                if (/iPhone|iPod/.test(ua)) return true
                if (/Android/i.test(ua) && window.innerWidth < 768) return true
                return false
            },
            svgToPngBlob(svgData) {
                return new Promise((resolve, reject) => {
                    const img = new Image()
                    img.onload = () => {
                        const canvas = document.createElement('canvas')
                        const size = 600
                        canvas.width = size
                        canvas.height = size
                        const ctx = canvas.getContext('2d')
                        ctx.fillStyle = '#FFFFFF'
                        ctx.fillRect(0, 0, size, size)
                        ctx.drawImage(img, 0, 0, size, size)
                        canvas.toBlob((blob) => {
                            if (blob) resolve(blob)
                            else reject(new Error('CANVAS_FAILED'))
                        }, 'image/png')
                    }
                    img.onerror = () => reject(new Error('IMG_LOAD_FAILED'))
                    if (svgData.startsWith('data:')) {
                        img.src = svgData
                    } else {
                        img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)))
                    }
                })
            },
            async downloadImage() {
                if (!this.qrcode || this.isDownloading) return

                this.isDownloading = true
                const orderId = this.$route.params.order_id_code || 'promptpay'
                const fileName = `promptpay-qr-${orderId}.png`

                try {
                    const proxyUrl = `proxyQrImage?url=${encodeURIComponent(this.qrcode)}`
                    const res = await http.get(proxyUrl, { responseType: 'blob' })

                    const contentType = res.headers['content-type'] || ''
                    let pngBlob

                    if (contentType.includes('json')) {
                        // Backend ไม่มี Imagick → ส่ง SVG เป็น base64 JSON กลับมา
                        const text = await res.data.text()
                        const json = JSON.parse(text)
                        const svgText = atob(json.svg)
                        pngBlob = await this.svgToPngBlob(svgText)
                    } else if (contentType.includes('svg')) {
                        // Backend ส่ง SVG กลับมาตรงๆ
                        const svgText = await res.data.text()
                        pngBlob = await this.svgToPngBlob(svgText)
                    } else {
                        // Backend ส่ง PNG กลับมา (Imagick แปลงแล้ว)
                        pngBlob = res.data
                    }

                    const file = new File([pngBlob], fileName, { type: 'image/png' })

                    if (navigator.canShare && navigator.canShare({ files: [file] })) {
                        await navigator.share({
                            files: [file],
                            title: 'PromptPay QR Code',
                        })
                    } else {
                        const url = URL.createObjectURL(pngBlob)
                        const link = document.createElement('a')
                        link.href = url
                        link.download = fileName
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                        URL.revokeObjectURL(url)
                    }
                } catch (error) {
                    if (error.name !== 'AbortError') {
                        this.$swal.fire({
                            icon: 'info',
                            title: 'ไม่สามารถบันทึกรูปได้',
                            text: 'กรุณากดค้างที่รูป QR Code แล้วเลือก "บันทึกรูปภาพ"',
                            confirmButtonText: 'ตกลง'
                        })
                    }
                } finally {
                    this.isDownloading = false
                }
            },
            retreiveQrcodeWithoutLogin(){
                http.get(`retreiveQrcodeWithoutLogin/${this.$route.params.order_id_code}/${this.$route.params.unmember_id_code}`)
                    .then(response => {
                        if(response.data.data == null){
                            this.$router.push({name: 'Donate'})
                        }else{
                            this.qrcode = response.data.data.qrcode
                            this.amount = response.data.data.amount
                            this.showText = true
                            this.timer = setInterval(() => {
                                this.retreiveQrcodeStatus()
                            }, 5000)
                        }
                    })
            },
            retreiveQrcode(){
                http.get(`riba/retreiveQrcode/${this.$route.params.order_id_code}`)
                    .then(response => {
                        if(response.data.data == null){
                            this.$router.push({name: 'Donate'})
                        }else{
                            this.qrcode = response.data.data.qrcode
                            this.amount = response.data.data.amount
                            this.showText = true
                            this.timer = setInterval(() => {
                                this.retreiveQrcodeStatus()
                            }, 5000)
                        }
                    })
            },
            retreiveQrcodeStatus(){
                if(this.checkingCount <= 30){
                    http.get(`retreiveQrcodeStatus/${this.$route.params.order_id_code}`)
                        .then(response => {
                            if(response.data.status == 'successful'){
                                clearInterval(this.timer)
                                this.$swal.fire({
                                    icon: 'success',
                                    title: 'สำเร็จ',
                                    text: 'ขอบคุณที่ร่วมสนับสนุน ขอความบารอกัตและความดีงามบังเกิดแก่ท่านและครอบครัว',
                                    confirmButtonText: 'ตกลง'
                                }).then(() => {
                                    this.$router.push({name: 'Donate'})
                                })
                            }else{
                                this.checkingCount++
                            }
                        })
                }else{
                    clearInterval(this.timer)
                    this.$swal.fire({
                        title: 'ท่านยังไม่ได้ชำระเงิน',
                        text: "ยังต้องการดำเนินการต่อหรือไม่!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'ไม่',
                        confirmButtonText: 'ใช่',
                        }).then((result) => {
                            if(result.isConfirmed){
                                this.checkingCount = 0
                                this.timer = setInterval(() => {
                                    this.retreiveQrcodeStatus()
                                }, 5000)
                            }else{
                                this.$router.push({name: 'PaymentHistories'})
                            }
                        })
                }
            },
            showMoney(money){
                return filter.numberFormat(money, '0,0.00')
            },
        },
        beforeUnmount () {
            clearInterval(this.timer)
        }
    }
</script>